$( "#langSelector" ).click(function() {
    $("#langDropdown").toggleClass('show');
});



document.addEventListener("click", e => {
    const isDropdownButton = e.target.matches("[data-dropdown-button]");
    if (!isDropdownButton && e.target.closest("[data-dropdown]") != null) return;

    let currentDropdown;
    if (isDropdownButton) {
        currentDropdown = e.target.closest("[data-dropdown]");
        currentDropdown.classList.toggle("active");
    }

    document.querySelectorAll("[data-dropdown].active").forEach(dropdown => {
        if (dropdown === currentDropdown) return;
        dropdown.classList.remove("active");
    })
})



$("#hamburger").click(function() {
    if ($(".header__content").hasClass('open')) {
        $(".header__content").removeClass('open');
        $("#hamburger").removeClass('open');
        // $(".menu__content").removeClass('open');
        // setTimeout(function(){
        //     $(".menu__symptoms").removeClass('open');
        //     $(".menu__style").removeClass('open');
        // }, 200);
        // setTimeout(function(){
        //     $(".menu__symptoms").removeClass('open');
        //     $(".menu__secondary").removeClass('open');
        // }, 300);
        // setTimeout(function(){
        //     $(".menu__primary").removeClass('open');
        // }, 700);
        // setTimeout(function(){
        //     $(".menu").removeClass('open');
        //     $(".navbar").removeClass('open');
        //     $("#hamburger").removeClass('open');
        // }, 800);

    } else {
        $(".header__content").addClass('open');
        // $(".navbar").addClass('open');
        $("#hamburger").addClass('open');
        // setTimeout(function(){
        //     $(".menu__primary").addClass('open');
        // }, 50);
        // setTimeout(function(){
        //     $(".menu__content").addClass('open');
        // }, 100);
        // setTimeout(function(){
        //     $(".menu__secondary").addClass('open');
        // }, 300);
        // setTimeout(function(){
        //     $(".menu__symptoms").addClass('open');
        //     $(".menu__style").addClass('open');
        //     menuSymptomSlide.init();
        //     menuLifeStyle.init();
        // }, 400);
    }
});
